<template>
  <div class="wrapper col-md-6">
    <div class="panel panel-default">
      <div class="panel-title">
        <h3>Prospects</h3>

        <router-link :to="{ name: 'prospects' }">
          <span class="btn btn-sm btn-primary top-right m-b-15">
            Voir tout
          </span>
        </router-link>

      </div>
      <div class="panel-body"
           v-if="this.prospects.length">
        <prospects-recalls-item v-for="(prospect, idx) in prospects"
                                :key="'dashboard-prospects-recall-'+idx"
                                v-if="idx < 3"
                                :prospect="prospect">
        </prospects-recalls-item>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .wrapper {
    padding-left: 10px;
    padding-right: 10px;
    @media all and (max-width: 1199px) {
      width: 100%;
      padding: 0;
    }
  }

  .panel {
    padding: 0;
    background: transparent;
    border: none;
    @media all and (max-width: 767px) {
      padding: 0 20px;
    }
    .panel-title {
      position: relative;
      h3 {
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
      }
      button {
        position: absolute;
        right: 5px;
      }
    }
    .panel-body {
      padding: 0;
    }
  }
</style>

<script type="text/babel">
  import { mapState, mapActions } from 'vuex'
  import ProspectsRecallsItem from 'components/Dashboard/ProspectsRecalls/ProspectsRecallsItem'

  export default {
    name: "ProspectsRecalls",

    props: ["prospects"],

    components: {
      ProspectsRecallsItem
    },

    data () {
      return {}
    },

  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/ProspectsRecalls/ProspectsRecalls.vue